export const BASE_URL = '/api'
export const REGISTRY_COUNTRIES = BASE_URL + '/registry/countries'
